import ArchitectureOfModernLLMs from './ArchitectureOfModernLLMs/ArchitectureOfModernLLMs';
import llmArchitectureImage from './ArchitectureOfModernLLMs/Resources/LLM Architecture.png';

// Registry of all blog articles. Newest first — the first entry is shown as featured on /blog.
const blogs = [
  {
    slug: 'architecture-of-modern-llms',
    title: 'Architecture of Modern LLMs',
    excerpt:
      'A layer-by-layer walkthrough of the decoder-only Transformer — embeddings, attention heads, feed-forward networks and Mixture of Experts — with tensor shapes and the key formula at every stage.',
    category: 'Research',
    tags: ['LLMs', 'Transformers', 'Attention', 'Mixture of Experts'],
    date: 'Oct 22, 2026',
    readTime: '18 min read',
    author: 'Silwren™ Research',
    image: llmArchitectureImage,
    component: ArchitectureOfModernLLMs,
  },
];

export default blogs;
